

























import Vue from 'vue';

export default Vue.component('CardHeader', {
  name: 'CardHeader',
  props: {
    title: {
      type: String,
      default: '',
    },
    titleStyle: {
      type: String,
      default: 'text-white',
    },
    leftButton: {
      type: String,
      default: 'Back',
    },
    leftButtonStyle: {
      type: String,
      default: 'text-white',
    },
    leftButtonAction: {
      type: Function,
      default: () => {
        window.history.back();
      },
    },
    rightButton: {
      type: String,
      default: '',
    },
    rightButtonStyle: {
      type: String,
      default: 'text-white',
    },
    rightButtonAction: {
      type: Function,
      default: () => {
        return;
      },
    },
    backgroundImage: String,
    backgroundStyle: {
      type: String,
      default: 'secondary',
    },
  },
  methods: {
    backgroundClass(): string {
      if (this.backgroundImage) {
        return 'overlay-70 overlay-' + this.backgroundStyle;
      }
      return 'overlay-' + this.backgroundStyle;
    },
    backgroundStyleComputed(): string {
      if (this.backgroundImage) {
        return 'background-image: url(' + this.backgroundImage + ');';
      }
      return '';
    },
  },
});
